// LiveStreamCarousel.jsx
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import SlidersImage from "../assets/images/for-slider-image.jpg";
import ProfileImage from "../assets/images/slider-profile-image.jpg";
import { useNavigate } from "react-router";
import { getChannelName } from "../helper/functions";
import { useSocket } from "../pages/livestream/useSocket";
import { useGlobalSearch } from "../context/GlobalSearchContext";

// import ClockImage from "../assets/images/clock-image.svg";

const streams = [
  {
    id: 1,
    thumbnail: SlidersImage,
    title: "Valorant Ranked Matches",
    user: "Alen Walk",
    viewers: "2.4K watching",
    tags: ["Competitive", "Casual"],
    live: true,
  },
  {
    id: 2,
    thumbnail: SlidersImage,
    title: "CS:GO Clutch Moments",
    user: "GhostRider",
    viewers: "1.2K watching",
    tags: ["Pro", "Intense"],
    live: false,
  },
  {
    id: 3,
    thumbnail: SlidersImage,
    title: "Minecraft Build Battle",
    user: "PixelMaster",
    viewers: "900 watching",
    tags: ["Creative", "Fun"],
    live: true,
  },
  {
    id: 4,
    thumbnail: SlidersImage,
    title: "Minecraft Build Battle",
    user: "PixelMaster",
    viewers: "900 watching",
    tags: ["Creative", "Fun"],
    live: true,
  },
  {
    id: 5,
    thumbnail: SlidersImage,
    title: "Minecraft Build Battle",
    user: "PixelMaster",
    viewers: "900 watching",
    tags: ["Creative", "Fun"],
    live: true,
  },
  {
    id: 6,
    thumbnail: SlidersImage,
    title: "Minecraft Build Battle",
    user: "PixelMaster",
    viewers: "900 watching",
    tags: ["Creative", "Fun"],
    live: true,
  },
  {
    id: 7,
    thumbnail: SlidersImage,
    title: "Minecraft Build Battle",
    user: "PixelMaster",
    viewers: "900 watching",
    tags: ["Creative", "Fun"],
    live: true,
  },
];

const LiveStreamCarousel = () => {
  const { globalSearch } = useGlobalSearch();
  const [livestreams, setLivestreams] = useState([]);
  // ------------- connect to sockets ---------------
  const socket = useSocket(globalSearch);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setReady(true);
    }, 200);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (socket) {
      setLivestreams(socket);
    }
  }, [socket, globalSearch]);

  const navigate = useNavigate();
  return (
    <div className="carousel-wrapper">
      {ready && (
        <Swiper
          modules={[EffectCoverflow, Navigation]}
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          loop
          navigation
          breakpoints={{
            480: {
              slidesPerView: 1,
              coverflowEffect: {
                depth: 150,
              },
            },
            768: {
              slidesPerView: 1.8,
              coverflowEffect: {
                depth: 300,
              },
            },
            1024: {
              slidesPerView: 2.3,
              coverflowEffect: {
                depth: 380,
              },
            },
            1280: {
              slidesPerView: 2.5,
              coverflowEffect: {
                depth: 400,
              },
            },
          }}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 400,
            modifier: 1,
            slideShadows: false,
          }}
          className="livestream-swiper"
        >
          {livestreams?.length === 0 ? (
            <p style={{ textAlign: "center", padding: "20px", color: "#999" }}>
              No live streams found
            </p>
          ) : (
            livestreams.map((stream) => {
              return (
                <SwiperSlide key={stream?.id} className="livestream-slide">
                  <div
                    className="livestream-card"
                    onClick={() => navigate("/live-stream")}
                  >
                    <div className="for-live-video-grid-inner-image for-live-video-grid-inner-image-livve">
                      {stream?.streamLink.includes("twitch.tv") ? (
                        <iframe
                          src={`https://player.twitch.tv/?channel=${getChannelName(
                            stream?.streamLink
                          )}&parent=${
                            window.location.hostname
                          }&autoplay=false&muted=true`}
                          width="100%"
                          height="100%"
                          frameBorder="0"
                          allow="autoplay"
                          allowFullScreen
                        ></iframe>
                      ) : (
                        <iframe
                          src={`https://player.kick.com/${getChannelName(
                            stream.streamLink
                          )}?autoplay=false&muted=true`}
                          width="100%"
                          height="100%"
                          frameBorder="0"
                          allow="autoplay"
                          allowFullScreen
                        ></iframe>
                      )}
                    </div>

                    <div
                      className="info-box"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        window.open(stream.streamLink, "_blank");
                      }}
                    >
                      <div className="profile-image-new">
                        <img src={ProfileImage} />
                      </div>
                      <h3>{stream?.name}</h3>
                      <p>{stream?.game.name}</p>
                      <span className="viewers">{stream?.viewers}</span>

                      <div className="for-player-tags">
                        <span>Competitive</span>
                        <span>Casual</span>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })
          )}
        </Swiper>
      )}
    </div>
  );
};

export default LiveStreamCarousel;
